import {connect} from 'react-redux';

import {gettext} from 'topmeteo/utils/i18n';

import {changeAnimationStop} from '../../../../general/actionCreators';

import Base, {getBounds as baseGetBounds} from './Base';

const Label = gettext('End time');

const getBounds = (node, {animationStart}) => {
    const {offset, width, rightBound} = baseGetBounds(node);
    const step = width / 24;

    return {
        offset,
        width,
        leftBound: step * (animationStart + 1),
        rightBound,
    };
};

const Stop = props => (
    <Base
        {...props}
        id="stop"
        title={Label}
        getBounds={getBounds}
    />
);

const mapStateToProps = ({animationStart, animationStop: index}) => ({
    animationStart,
    index,
});

const mapDispatchToProps = dispatch => ({
    onMove: (event, index) => dispatch(changeAnimationStop(index)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Stop);
